module.exports = __webpack_public_path__ + "static/media/ye.bb77153d.svg";